module.exports = __webpack_public_path__ + "img/icon-selected-route.734db847.svg";